import { useMutation } from "@tanstack/react-query";
import { IAddon } from "../../models/Addon";
import { AddonService } from "../../services/addon.service";

export const useAddonMutations = () => {
  const { mutate: createAddon } = useMutation<any, Error, Omit<IAddon, "id">>({
    mutationFn: async (model) => AddonService.createAddon(model),
  });

  const { mutate: updateAddon } = useMutation<
    any,
    Error,
    { id: string; model: Omit<IAddon, "id"> }
  >({
    mutationFn: async ({ id, model }) => AddonService.updateAddon(id, model),
  });

  const { mutate: deleteAddon } = useMutation<any, Error, string>({
    mutationFn: async (id) => AddonService.deleteAddon(id),
  });

  return {
    createAddon,
    updateAddon,
    deleteAddon,
  };
};
